import ForgotPasswordBody from "@/components/landing/auth/ForgotPasswordBody";

export default function ForgotPasswordTwoBody() {
  return <ForgotPasswordBody />;
}
